import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c4002620"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-sheet-section" }
const _hoisted_2 = { class: "m-sheet-data" }
const _hoisted_3 = { class: "m-sheet-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"16px"} }, "答题卡", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-res-labels" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "m-res-label u-todo-label" }, "未作答"),
  /*#__PURE__*/_createElementVNode("div", { class: "m-res-label u-done-label" }, "已作答")
], -1))
const _hoisted_6 = { class: "m-que-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "u-remarks"
}
const _hoisted_9 = { class: "m-sheet-footer flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args)))
        })
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.questionList, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.queId
          }, [
            (item.queId)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: ($event: any) => ($setup.handleTargetTile(index)),
                  class: _normalizeClass(["u-que-tile", { 'u-todo': item.unAnswered, 'u-done': !item.unAnswered }])
                }, _toDisplayString(index + 1), 11, _hoisted_7))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        ($setup.questionList.length > 5)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(5 - ($setup.questionList.length % 5), (index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "u-que-tile"
              }))
            }), 128))
          : _createCommentVNode("", true)
      ]),
      (!!$props.isAllDecidable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 注：不支持作答的试题，提交后系统默认作答结果正确 "))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleSubmit && $setup.handleSubmit(...args))),
        class: _normalizeClass({ disabled: $props.unAnsweredNum > 0 })
      }, "确认提交", 2)
    ], 512), [
      [_vShow, $props.showButton]
    ])
  ]))
}